import React, { useState, useEffect } from "react";
import { ContextTypes } from "src/static/interface";
import { useSearchParams, useLocation } from "react-router-dom";
import { useUserStore } from "src/store/userStore";

export const MainContext = React.createContext<ContextTypes>({
  loginOpen: false,
  profileOpen: false,
});

function MainContextProvider({ children }: { children?: React.ReactNode }) {
  const [testStartModal, setTestStartModal] = useState(false);
  const [testPackageId, setTestPackageId] = useState(0);
  const [endTime, setEndTime] = useState(0);

  // Search bar maker
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const handleMakeParams = (key: string, value: string) => {
    if (value) {
      if (searchParams.has(key)) searchParams.set(key, value);
      else searchParams.append(key, value);
    } else searchParams.delete(key);
    setSearchParams(searchParams);
  };

  //Set generate code
  const [generateCode, setGenerateCode] = useState<number | undefined>();

  //Login modal visible
  const [loginOpen, setLoginOpen] = useState(false);

  //Profile dropdown visible
  const [profileOpen, setProfileOpen] = useState(false);

  // Set user phone
  const [userPhone, setUserPhone] = useState<string>("");

  // Zustand store'dan fetchTeacherInfo'ni olish
  const fetchTeacherInfo = useUserStore((state) => state.fetchTeacherInfo);

  // Load teacher info from API on mount and when location changes
  // userInfo mavjud bo'lsa ham har safar yangilanadi
  useEffect(() => {
    // Har safar sahifa o'zgarganda yoki mount bo'lganda yangilash
    fetchTeacherInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]); // Location o'zgarganda va mount bo'lganda ishlaydi

  // Window focus bo'lganda ham yangilash (sahifa yangilanganda yoki tab o'zgarganda)
  useEffect(() => {
    const handleFocus = () => {
      fetchTeacherInfo();
    };

    window.addEventListener('focus', handleFocus);
    
    return () => {
      window.removeEventListener('focus', handleFocus);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <MainContext.Provider
      value={{
        handleMakeParams,
        testStartModal,
        setTestStartModal,
        testPackageId,
        setTestPackageId,
        endTime,
        setEndTime,
        userPhone,
        setUserPhone,
        loginOpen,
        setLoginOpen,
        profileOpen,
        setProfileOpen,
        generateCode,
        setGenerateCode,
      }}
    >
      {children}
    </MainContext.Provider>
  );
}

export default MainContextProvider;
